import {
    UPLOAD_MONITORING_OLD_DATA_RESPONSE, MONITORING_DOWNLOAD_COUNTERPARTY_DATA_RESPONSE, FETCH_MONITORING_LIST_RESPONSE,
    CREATE_MONITORING_METADATA_RESPONSE, UPLOAD_MONITORING_DATA_RESPONSE, UPLOAD_MONITORING_TEMPLATE_RESPONSE,
    INITIATE_MONITORING_RESPONSE, STOP_MONITORING_RESPONSE, DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_RESPONSE,
    DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_RESPONSE, PUBLISH_MONITORING_REPORT_RESPONSE,
    DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_RESPONSE, CORPORATE_MONITORING_DATA_RESPONSE, MONITORING_CORPORATE_LIST_RESPONSE,
    DOWNLOAD_CORPORATE_MONITORING_REPORT_RESPONSE, DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_RESPONSE, SEND_CORPORATE_MONITORING_REPORT_RESPONSE, SEND_MONITORING_BULK_REPORT_RESPONSE, 
    DOWNLOAD_EWS_REPORT_RESPONSE, EWS_PUBLISH_LIST_RESPONSE, CORPORATE_EWS_DATA_RESPONSE} from './action';

const monitoringDataReducer = (state = {}, action) => {
    switch (action.type) {
        case UPLOAD_MONITORING_OLD_DATA_RESPONSE:
            return {
                ...state,
                monitoringDataUploadResponse: action.data
            }

        case MONITORING_DOWNLOAD_COUNTERPARTY_DATA_RESPONSE:
            return {
                ...state,
                monitoringCounterpartyData: action.data
            }

        case FETCH_MONITORING_LIST_RESPONSE:
            return {
                ...state,
                monitoringList: action.data.data
            }

        case CREATE_MONITORING_METADATA_RESPONSE:
            return {
                ...state,
                monitoringMetadataResponse: action.data
            }

        case UPLOAD_MONITORING_DATA_RESPONSE:
            return {
                ...state,
                monitoringProcess: action.data
            }

        case UPLOAD_MONITORING_TEMPLATE_RESPONSE:
            return {
                ...state,
                templateUpload: action.data
            }
        case INITIATE_MONITORING_RESPONSE:
            return {
                ...state,
                initiateMonitoring: action.data
            }
        case STOP_MONITORING_RESPONSE:
            return {
                ...state,
                stopMonitoring: action.data
            }
        case DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_RESPONSE:
            return {
                ...state,
                consolidatedMonitoringReport: action.data
            }

        case DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_RESPONSE:
            return {
                ...state,
                monitoringCrawlerStatus: action.data
            }

        case CORPORATE_MONITORING_DATA_RESPONSE:
            return {
                ...state,
                corporateMonitoringData: action.data.data
            }

        case MONITORING_CORPORATE_LIST_RESPONSE:
            return {
                ...state,
                monitoringCorporateList: action.data
            }

        case DOWNLOAD_CORPORATE_MONITORING_REPORT_RESPONSE:
            return {
                ...state,
                corporateMonitoringReport: action.data
            }
        case DOWNLOAD_EWS_REPORT_RESPONSE:
            return {
                ...state,
                corporateEWSReport: action.data
            }

        case SEND_CORPORATE_MONITORING_REPORT_RESPONSE:
            return {
                ...state,
                sendCorporateMonitoringReport: action.data
            }

        case SEND_MONITORING_BULK_REPORT_RESPONSE:
            return {
                ...state,
                sendMonitoringBulkReport: action.data
            }

        case DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_RESPONSE:
            return {
                ...state,
                monitoringScoreCalculationTemplate: action.data
            }

        case PUBLISH_MONITORING_REPORT_RESPONSE:
            return {
                ...state,
                publishReportData: action.data
            }

        case DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_RESPONSE:
            return {
                ...state,
                oldOrOfflineDataUploadtemplate: action.data
            }
        case EWS_PUBLISH_LIST_RESPONSE:
            return {
                ...state,
                publishList: action.data
            }
        case CORPORATE_EWS_DATA_RESPONSE:
            return {
                ...state,
                corporateMonitoringData: action.data.data
            }

        default:
            return state
    }
}

export default monitoringDataReducer;